import React from 'react';
import { LoaderContainer } from './styled';

export default function Loader() {
  return (
    <LoaderContainer>
      <img src="/images/loader_gif.gif" alt="Loading" />
    </LoaderContainer>
  );
}
